import type { ReactNode } from 'react';

/**
 * Per-step header + body shell. The selection-count + Clear row sits
 * directly under the hint so the user always sees their progress on
 * the current filter *before* scrolling into the picker - pairs intent
 * (title) with current state (count).
 */
export function StepShell({
  title,
  hint,
  selectionLabel,
  onClear,
  children,
}: {
  title: string;
  hint: string;
  /** When provided, renders the "N selected" row + Clear button under
   *  the hint. Pass undefined when the step has nothing to clear
   *  (Length, Review). */
  selectionLabel?: string | null;
  onClear?: () => void;
  children: ReactNode;
}) {
  return (
    <div className='space-y-4'>
      <div>
        <h3 className='text-base font-semibold text-foreground'>{title}</h3>
        <p className='mt-1 text-xs text-muted-foreground max-sm:text-sm'>
          {hint}
        </p>
        {selectionLabel && (
          <div className='mt-3 flex items-center justify-between gap-3 border-t border-border pt-3'>
            <span className='text-xs font-medium text-foreground'>
              {selectionLabel}
            </span>
            {onClear && (
              <button
                type='button'
                onClick={onClear}
                className='tap-target text-xs font-medium text-muted-foreground underline-offset-2 hover:text-foreground hover:underline max-sm:text-sm max-sm:text-foreground'
              >
                Clear
              </button>
            )}
          </div>
        )}
      </div>
      {children}
    </div>
  );
}
